module.exports = __webpack_public_path__ + "media/images/gallery/constellations/cancer/cnc_vis-c41caa871653c44247b7e5de9a93c777.jpg";